import { action } from '@ember/object';
import { service } from '@ember/service';
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import type AccessEventModel from 'garaje/models/access-event';
import type PersonAccessEventGroupModel from 'garaje/models/person-access-event-group';
import type StateService from 'garaje/services/state';

interface PersonGroupArgs {
  personGroup: PersonAccessEventGroupModel;
  isExpanded: boolean;
  onToggle: (groupId: string) => void;
  fieldOptions: Array<{
    name: string;
    componentName: string;
    show?: boolean;
    disabled?: boolean;
    sort?: string;
    tooltip?: string;
  }>;
  startDate?: Date | null;
  endDate?: Date | null;
}

export default class PersonGroup extends Component<PersonGroupArgs> {
  @service declare state: StateService;

  @tracked isExpanded = false;

  get groupId(): string {
    return this.args.personGroup.id;
  }

  get events(): AccessEventModel[] {
    return this.args.personGroup.result?.slice() ?? [];
  }

  get hasEvents(): boolean {
    return this.events.length > 0;
  }

  get eventRowClasses(): string[] {
    return this.events.map((_, i) => (i % 2 === 0 ? 'bg-white hover:bg-carbon-5' : 'bg-carbon-5 hover:bg-carbon-10'));
  }

  get personName(): string {
    return this.events[0]?.displayName ?? '';
  }

  get hasFailures(): boolean {
    return this.events.some((e) => !!e.failureReason);
  }

  get displayIntegrations(): string {
    const names = [...new Set(this.events.map((e) => e.integrationName).filter(Boolean))];
    return names.join(', ');
  }

  get displayEntrances(): string {
    const names = [...new Set(this.events.map((e) => e.entranceName).filter(Boolean))];
    return names.join(', ');
  }

  @action
  handleToggle(): void {
    this.isExpanded = !this.isExpanded;
    // eslint-disable-next-line no-console
    console.log('handleToggle called for person group:', this.groupId, 'isExpanded:', this.isExpanded);
    this.args.onToggle(this.groupId);
  }
}
